/**
 * Ermittelt das Fenster der sichtbaren Seitenzahlen.
 *
 * Passen alle Seiten ins Fenster, werden sie vollstaendig gezeigt. Sonst wird
 * die aktuelle Seite mittig gehalten und das Fenster an den Raendern
 * zurueckgeschoben, damit es immer `maxVisiblePages` Eintraege umfasst.
 *
 * Bewusst als reine Funktion neben der Komponente: Rechnen gehoert nicht ins
 * JSX und laesst sich so direkt pruefen.
 */
export const getVisiblePages = (
  currentPage: number,
  totalPages: number,
  maxVisiblePages: number
): number[] => {
  if (totalPages <= maxVisiblePages) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const half = Math.floor(maxVisiblePages / 2);
  let start = Math.max(1, currentPage - half);
  const end = Math.min(totalPages, start + maxVisiblePages - 1);

  if (end - start + 1 < maxVisiblePages) {
    start = Math.max(1, end - maxVisiblePages + 1);
  }

  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};
